export default __webpack_public_path__ + "9d2f610c73044633783b85817e3bca6a.wav";